import { render, staticRenderFns } from "./DeviceBrand.vue?vue&type=template&id=84439466&scoped=true&"
import script from "./DeviceBrand.vue?vue&type=script&lang=js&"
export * from "./DeviceBrand.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBrand.vue?vue&type=style&index=0&id=84439466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84439466",
  null
  
)

export default component.exports